import convertDataAttributesToObject from "@projLib/convertDataAttributesToObejct";
export default class AsyncModules {
    static init(modules, queryElement = document.documentElement) {
        (modules !== null && modules !== void 0 ? modules : []).forEach(({ selector, moduleName, defaultArgs }) => {
            var _a;
            ((_a = queryElement.querySelectorAll(selector)) !== null && _a !== void 0 ? _a : []).forEach((el) => {
                var _a;
                const formattedArgs = convertDataAttributesToObject((_a = el.dataset) !== null && _a !== void 0 ? _a : {});
                const args = Object.assign(Object.assign({}, defaultArgs), formattedArgs);
                return AsyncModules.load(el, moduleName, args);
            });
        });
    }
    static load(el, moduleName, args) {
        try {
            return import(`@projModules/${moduleName}`).then((mod) => {
                const Module = mod.default;
                return new Module(el, args);
            });
        }
        catch (error) {
            const err = error;
            // eslint-disable-next-line no-console
            console.warn(err);
        }
        return false;
    }
}
